module.exports = {
  transparent: 'transparent',
  white: '#FFFFFF',
  black: '#000000',
  gold: '#A4804A',
  silver: '#8a8d8f',
  gray: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#E5E5E5',
    300: '#D4D4D4',
    400: '#A3A3A3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
  },
  'gray-warm': {
    50: '#FAFAF9',
    100: '#F5F5F4',
    200: '#E7E5E4',
    300: '#D6D3D1',
    400: '#A8A29E',
    500: '#78716C',
    600: '#57534E',
    700: '#44403C',
    800: '#292524',
    900: '#1C1917',
  },
  'gray-cool': {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },
  'gray-indigo': {
    50: '#FAFAFA',
    100: '#F4F4F5',
    200: '#E4E4E7',
    300: '#D4D4D8',
    400: '#A1A1AA',
    500: '#71717A',
    600: '#52525B',
    700: '#3F3F46',
    800: '#27272A',
    900: '#18181B',
  },
  red: {
    50: '#FDE2E7',
    100: '#FCCAD2',
    200: '#FDB4C1',
    300: '#FA7F94',
    400: '#F44865',
    500: '#D8132D',
    600: '#C8102E',
    700: '#AA1D25',
    800: '#8B1E1E',
    900: '#791616',
  },
  orange: {
    50: '#FFF5EB',
    100: '#FFEBD0',
    200: '#FED2A1',
    300: '#FCB169',
    400: '#FA8834',
    500: '#F86716',
    600: '#E64E0E',
    700: '#BB390F',
    800: '#902E13',
    900: '#712812',
  },
  yellow: {
    50: '#FEFBE5',
    100: '#FEF8BB',
    200: '#FDED7E',
    300: '#FDDB3F',
    400: '#FAC515',
    500: '#E6AA0A',
    600: '#C37F05',
    700: '#965709',
    800: '#7A4410',
    900: '#663713',
  },
  green: {
    50: '#EDFDF3',
    100: '#D7FBE3',
    200: '#C6F6D5',
    300: '#9AE6B4',
    400: '#68D391',
    500: '#48BB78',
    600: '#38A169',
    700: '#2F855A',
    800: '#276749',
    900: '#22543D',
  },
  teal: {
    50: '#EEFDFA',
    100: '#C5FBEF',
    200: '#8EF4E0',
    300: '#54E7CF',
    400: '#28CEB8',
    500: '#14B09D',
    600: '#0F897D',
    700: '#106B62',
    800: '#12534E',
    900: '#144541',
  },
  aqua: {
    50: '#EDFAFA',
    100: '#C8F2F9',
    200: '#A2E9F6',
    300: '#71DCEF',
    400: '#52CFE5',
    500: '#2BB2CA',
    600: '#2097AC',
    700: '#1C7382',
    800: '#155460',
    900: '#123D46',
  },
  blue: {
    50: '#EBF8FF',
    100: '#D9F2FF',
    200: '#BEE3F8',
    300: '#90CDF4',
    400: '#63B3ED',
    500: '#4299E1',
    600: '#3182CE',
    700: '#0067B5',
    800: '#22547C',
    900: '#2B435A',
  },
  'dark-blue': {
    50: '#EBF4FA',
    100: '#C7DFF0',
    200: '#A5C6E4',
    300: '#7AA3C7',
    400: '#5788B7',
    500: '#3E6A93',
    600: '#385D85',
    700: '#2D4D6C',
    800: '#213B54',
    900: '#1A2937',
  },
  indigo: {
    50: '#EBF0FE',
    100: '#DDE3FF',
    200: '#C0CCFE',
    300: '#9CABFD',
    400: '#7680F7',
    500: '#585BEF',
    600: '#463DE1',
    700: '#3B31C3',
    800: '#302A98',
    900: '#2B2875',
  },
}
